module.exports = __webpack_public_path__ + "static/sublime-8eea1256ca716beb5c0e6c8d143c5695.png";